import React from "react";
//import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Tracuuhoatdongtable from "components/Tracuuthongtin/Tracuuhoatdongtable.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";

export default function Tracuuhoatdong() {
  //const classes = useStyles();
  const [bienkiemsoat, setBienkiemsoat] = React.useState("");
  const [tungay, setTungay] = React.useState(dayjs());
  const [denngay, setDenngay] = React.useState(dayjs());
  const [doanhnghiep, setDoanhnghiep] = React.useState([]);
  const [hoatdong, setHoatdong] = React.useState([]);
  const [vipham, setVipham] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtinDN = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getphuongtientheosodangky?sodangky=" +
      bienkiemsoat +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDoanhnghiep(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gethoatdong = () => {
    var batdau =
      tungay.$y +
      "-" +
      String(tungay.$M + 1).padStart(2, "0") +
      "-" +
      tungay.$D;
    var ketthuc =
      denngay.$y +
      "-" +
      String(denngay.$M + 1).padStart(2, "0") +
      "-" +
      denngay.$D;
    var url =
      Config.backend +
      "/api/Phuongtien/getlshoatdongphuongtientheosodangky?sodangky=" +
      bienkiemsoat +
      "&tgbatdau=" +
      batdau +
      "&tgketthuc=" +
      ketthuc +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHoatdong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getvipham = () => {
    var url =
      Config.backend +
      "/api/ViPham/getviphamhtheosodangky?sodangky=" +
      bienkiemsoat +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setVipham(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={2} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "100%" }}>
          <TextField
            label="Biển kiểm soát"
            variant="outlined"
            size="small"
            value={bienkiemsoat}
            onChange={(event) => {
              setBienkiemsoat(event.target.value);
            }}
            InputLabelProps={{
              sx: {
                color: "red",
              },
            }}
            InputProps={{
              style: {
                height: 32,
              },
            }}
          />
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl style={{ width: "100%", marginTop: 5 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Từ ngày"
              value={tungay}
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                setTungay(newValue);
              }}
              slotProps={{ textField: { size: "small" } }}
              views={["day", "month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl style={{ width: "100%", marginTop: 3 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Đến ngày"
              value={denngay}
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                setDenngay(newValue);
              }}
              slotProps={{ textField: { size: "small" } }}
              views={["day", "month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl style={{ width: "70%", marginTop: 3 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 32 }}
            //disabled={!selectedFiles}
            onClick={() => {
              getthongtinDN();
              gethoatdong();
              getvipham();
            }}
          >
            Xem
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 6 }}>
        <Tracuuhoatdongtable
          doanhnghiep={doanhnghiep}
          hoatdong={hoatdong}
          vipham={vipham}
        />
      </GridItem>
    </GridContainer>
  );
}
